import { createSlice } from "@reduxjs/toolkit";
import {
  getStaffList,
  getEducationRankList,
  getPositionsList,
  getSpecialityList,
  getCabinetsList,
  createStaff,
  getStaffById,
  getTransferStatuses,
  getStaffArchiveList,
  getLessonTypeList,
  getSubjectsList,
  getSubjectsOptions,
  getNationalityList,
  getEducationYear,
  getSemestersList,
  getStudentTypeList,
  getShifts,
  getCabinetList,
  getCabinetBlocks,
  getSubjects,
  getSubjectEducation,
  getTeachers,
  getGroups,
  getCurators,
  getHeadCurses,
  getGroupNumber,
  getGroupCurriculum,
  getCurriculumExamType,
  getGroupStudents,
  getParentTypes,
  getGroupSchedule,
  getGroupLessonTime,
  getGroupSemesterDatas,
  getStudentById,
  updateStaff,
  getStaffs,
  getCollegeInfo,
  getEducationHolidays,
  getArchiveStatus,
  getArchivedStudents,
  createStudent,
  updateStudent,
  getTransferGroups,
  getTransferGroupStudents,
  getArchivedGroups,
  getStudentsControl,
  createPosition,
  updatePosition,
  addEducationRank,
  updateEducationRank,
  addSpeciality,
  addLessonType,
  addNationality,
  createEducationYear,
  createEducationHolidays,
  createSemester,
  createShift,
  getLanguages,
  addCity,
  getCities,
  getSocialStatuses,
  getTargetedTraining,
  addEducationSpeciality,
  getEducationSpeciality,
  addCabinetType,
  getCabinetTypes,
  addCafedra,
  getCafedras,
  getPersonIdByHikId,
  getStaffTypes,
} from "./api";

import {
  getJournalDates,
  getJournalOptions,
  getJournalStudents,
} from "pages/teacher/api";

const initialState = {
  staffListLoading: false,
  staffList: null,
  updateStaffLoading: false,
  addStudentLoading: false,
  updateStudentLoading: false,
  positions: null,
  specialities: null,
  educationRanks: null,
  cabinets: null,
  createStaffLoading: false,
  singleStaffObj: null,
  transferStatuses: null,
  staffArchiveList: null,
  lessonTypeList: null,
  subjectList: null,
  subjectsOptions: null,
  nationalityList: null,
  educationYears: null,
  semesters: null,
  studentTypes: null,
  shifts: null,
  cabinetsList: null,
  cabinetBlocks: null,
  cabinetSubjects: null,
  cabinetStaffs: null,
  subjectEducation: null,
  teachers: null,
  groupsList: null,
  curatorsList: null,
  headCursesList: null,
  groupNumbersList: null,
  groupCurriculum: null,
  curriculumExamTypes: null,
  groupStudents: null,
  parentTypes: null,
  groupSchedule: null,
  groupLessonTimes: null,
  isGetScheduleSuccess: false,
  groupSemesterDatas: null,
  singleStudentInfo: null,
  staffsOption: null,
  journalStudents: null,
  journalDates: null,
  collegeInfo: null,
  archiveStatus: null,
  archivedStudents: null,
  transferGroupsList: null,
  transferGroupStudents: null,
  archivedGroups: null,
  studentsControlData: null,
  createPositionLoading: false,
  addEducationRankLoading: false,
  addSpecialityLoading: false,
  addLessonTypeLoading: false,
  addNationalityLoading: false,
  createEducationYearLoading: false,
  createEducationHolidaysLoading: false,
  createSemesterLoading: false,
  createShiftLoading: false,
  languages: null,
  activeClassRoom: null,
  cities: null,
  addCityLoading: false,
  socialStatuses: null,
  targetedTrainings: null,
  addEduSpecLoading: false,
  eduSpecs: null,
  addCabinetTypeLoading: false,
  cabinetTypes: null,
  addCafedraLoading: false,
  cafedras: null,
  personIdResponse: null,
  staffTypes: null,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setSingleStaffObj(state, action) {
      state.singleStaffObj = action.payload;
    },
    setSingleStudentInfo(state, action) {
      state.singleStudentInfo = action.payload;
    },
    setGroupCurriculum(state, action) {
      state.groupCurriculum = action.payload;
    },

    setGroupsListOnArchivePage(state, action) {
      state.groupsList = action.payload;
    },

    setPersonId(state, action) {
      state.personIdResponse = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStaffList.pending, (state) => {
      state.staffListLoading = true;
    });
    builder.addCase(getStaffList.fulfilled, (state, action) => {
      state.staffListLoading = false;
      state.staffList = action.payload;
    });
    builder.addCase(getStaffList.rejected, (state) => {
      state.staffListLoading = false;
    });

    builder.addCase(getStaffArchiveList.pending, (state) => {
      state.staffListLoading = true;
    });
    builder.addCase(getStaffArchiveList.fulfilled, (state, action) => {
      state.staffListLoading = false;
      state.staffArchiveList = action.payload;
    });
    builder.addCase(getStaffArchiveList.rejected, (state) => {
      state.staffListLoading = false;
    });

    builder.addCase(getLessonTypeList.pending, (state) => {
      state.staffListLoading = true;
    });
    builder.addCase(getLessonTypeList.fulfilled, (state, action) => {
      state.staffListLoading = false;
      state.lessonTypeList = action.payload;
    });

    builder.addCase(createStudent.pending, (state) => {
      state.addStudentLoading = true;
    });
    builder.addCase(createStudent.fulfilled, (state, action) => {
      state.addStudentLoading = false;
    });
    builder.addCase(createStudent.rejected, (state) => {
      state.addStudentLoading = false;
    });

    builder.addCase(updateStudent.pending, (state) => {
      state.updateStudentLoading = true;
    });
    builder.addCase(updateStudent.fulfilled, (state, action) => {
      state.updateStudentLoading = false;
    });
    builder.addCase(updateStudent.rejected, (state) => {
      state.updateStudentLoading = false;
    });

    builder.addCase(getLessonTypeList.rejected, (state) => {
      state.staffListLoading = false;
    });
    builder.addCase(getNationalityList.fulfilled, (state, action) => {
      state.nationalityList = action.payload;
    });

    builder.addCase(getSubjectsList.pending, (state) => {
      state.staffListLoading = true;
    });
    builder.addCase(getSubjectsList.fulfilled, (state, action) => {
      state.staffListLoading = false;
      state.subjectList = action.payload;
    });
    builder.addCase(getSubjectsList.rejected, (state) => {
      state.staffListLoading = false;
    });
    builder.addCase(getStaffById.fulfilled, (state, action) => {
      state.staffListLoading = false;
      state.singleStaffObj = action.payload;
    });

    builder.addCase(getStudentTypeList.fulfilled, (state, action) => {
      state.studentTypes = action.payload;
    });

    builder.addCase(getEducationRankList.fulfilled, (state, action) => {
      state.educationRanks = action.payload;
    });

    builder.addCase(getPositionsList.fulfilled, (state, action) => {
      state.positions = action.payload;
    });

    builder.addCase(getSpecialityList.fulfilled, (state, action) => {
      state.specialities = action.payload;
    });

    builder.addCase(getTransferStatuses.fulfilled, (state, action) => {
      state.transferStatuses = action.payload;
    });

    builder.addCase(getCabinetsList.fulfilled, (state, action) => {
      state.cabinets = action.payload?.map((el) => ({
        id: el.cabinet_id,
        name: el.cabinet_number,
      }));
    });

    builder.addCase(createStaff.pending, (state) => {
      state.createStaffLoading = true;
    });
    builder.addCase(createStaff.fulfilled, (state, action) => {
      state.createStaffLoading = false;
    });
    builder.addCase(createStaff.rejected, (state) => {
      state.createStaffLoading = false;
    });

    builder.addCase(updateStaff.pending, (state) => {
      state.updateStaffLoading = true;
    });
    builder.addCase(updateStaff.fulfilled, (state, action) => {
      state.updateStaffLoading = false;
    });
    builder.addCase(updateStaff.rejected, (state) => {
      state.updateStaffLoading = false;
    });

    // updateStaff
    builder.addCase(getSubjectsOptions.fulfilled, (state, action) => {
      state.subjectsOptions = action.payload;
    });
    builder.addCase(getEducationYear.fulfilled, (state, action) => {
      state.educationYears = action.payload;
    });
    builder.addCase(getEducationHolidays.fulfilled, (state, action) => {
      state.educationHolidays = action.payload;
    });

    builder.addCase(getSemestersList.fulfilled, (state, action) => {
      state.semesters = action.payload;
    });

    builder.addCase(getShifts.fulfilled, (state, action) => {
      state.shifts = action.payload;
    });

    builder.addCase(getCabinetList.fulfilled, (state, action) => {
      state.cabinetsList = action.payload;
    });

    builder.addCase(getCabinetBlocks.fulfilled, (state, action) => {
      state.cabinetBlocks = action.payload;
    });

    builder.addCase(getSubjects.fulfilled, (state, action) => {
      state.cabinetSubjects = action.payload;
    });

    builder.addCase(getStaffs.fulfilled, (state, action) => {
      state.cabinetStaffs = action.payload;
    });

    builder.addCase(getSubjectEducation.fulfilled, (state, action) => {
      state.subjectEducation = action.payload;
    });

    builder.addCase(getTeachers.fulfilled, (state, action) => {
      state.teachers = action.payload;
    });

    builder.addCase(getGroups.fulfilled, (state, action) => {
      state.groupsList = action.payload;
    });

    builder.addCase(getCurators.fulfilled, (state, action) => {
      state.curatorsList = action.payload;
    });

    builder.addCase(getHeadCurses.fulfilled, (state, action) => {
      state.headCursesList = action.payload;
    });

    builder.addCase(getGroupNumber.fulfilled, (state, action) => {
      state.groupNumbersList = action.payload;
    });

    builder.addCase(getGroupCurriculum.fulfilled, (state, action) => {
      state.groupCurriculum = action.payload;
    });

    builder.addCase(getCurriculumExamType.fulfilled, (state, action) => {
      state.curriculumExamTypes = action.payload;
    });

    builder.addCase(getGroupStudents.fulfilled, (state, action) => {
      state.groupStudents = action.payload;
    });

    builder.addCase(getParentTypes.fulfilled, (state, action) => {
      state.parentTypes = action.payload;
    });

    builder.addCase(getGroupSchedule.fulfilled, (state, action) => {
      state.groupSchedule = action.payload;
      state.isGetScheduleSuccess = true;
    });

    builder.addCase(getGroupLessonTime.fulfilled, (state, action) => {
      state.groupLessonTimes = action.payload;
    });

    builder.addCase(getGroupSemesterDatas.fulfilled, (state, action) => {
      state.groupSemesterDatas = action.payload;
    });

    builder.addCase(getStudentById.fulfilled, (state, action) => {
      state.singleStudentInfo = action.payload;
    });

    builder.addCase(getJournalDates.fulfilled, (state, action) => {
      state.journalDates = null;
      state.journalDates = action.payload;
    });

    builder.addCase(getJournalStudents.fulfilled, (state, action) => {
      state.journalStudents = action.payload;
    });

    builder.addCase(getCollegeInfo.fulfilled, (state, action) => {
      state.collegeInfo = action.payload;
    });

    builder.addCase(getArchiveStatus.fulfilled, (state, action) => {
      state.archiveStatus = action.payload;
    });

    builder.addCase(getArchivedStudents.fulfilled, (state, action) => {
      state.archivedStudents = action.payload;
    });

    builder.addCase(getTransferGroups.fulfilled, (state, action) => {
      state.transferGroupsList = action.payload;
    });

    builder.addCase(getTransferGroupStudents.fulfilled, (state, action) => {
      state.transferGroupStudents = action.payload;
    });

    builder.addCase(getArchivedGroups.fulfilled, (state, action) => {
      state.archivedGroups = action.payload;
    });

    builder.addCase(getStudentsControl.fulfilled, (state, action) => {
      state.studentsControlData = action.payload;
    });

    builder.addCase(createPosition.pending, (state) => {
      state.createPositionLoading = true;
    });
    builder.addCase(createPosition.fulfilled, (state, action) => {
      state.createPositionLoading = false;
    });
    builder.addCase(createPosition.rejected, (state) => {
      state.createPositionLoading = false;
    });

    builder.addCase(updatePosition.pending, (state) => {
      state.createPositionLoading = true;
    });
    builder.addCase(updatePosition.fulfilled, (state, action) => {
      state.createPositionLoading = false;
    });
    builder.addCase(updatePosition.rejected, (state) => {
      state.createPositionLoading = false;
    });

    builder.addCase(addEducationRank.pending, (state) => {
      state.addEducationRankLoading = true;
    });
    builder.addCase(addEducationRank.fulfilled, (state, action) => {
      state.addEducationRankLoading = false;
    });
    builder.addCase(addEducationRank.rejected, (state) => {
      state.addEducationRankLoading = false;
    });

    builder.addCase(updateEducationRank.pending, (state) => {
      state.addEducationRankLoading = true;
    });
    builder.addCase(updateEducationRank.fulfilled, (state, action) => {
      state.addEducationRankLoading = false;
    });
    builder.addCase(updateEducationRank.rejected, (state) => {
      state.addEducationRankLoading = false;
    });

    builder.addCase(addSpeciality.pending, (state) => {
      state.addSpecialityLoading = true;
    });
    builder.addCase(addSpeciality.fulfilled, (state, action) => {
      state.addSpecialityLoading = false;
    });
    builder.addCase(addSpeciality.rejected, (state) => {
      state.addSpecialityLoading = false;
    });

    builder.addCase(addLessonType.pending, (state) => {
      state.addLessonTypeLoading = true;
    });
    builder.addCase(addLessonType.fulfilled, (state, action) => {
      state.addLessonTypeLoading = false;
    });
    builder.addCase(addLessonType.rejected, (state) => {
      state.addLessonTypeLoading = false;
    });

    builder.addCase(addNationality.pending, (state) => {
      state.addNationalityLoading = true;
    });
    builder.addCase(addNationality.fulfilled, (state, action) => {
      state.addNationalityLoading = false;
    });
    builder.addCase(addNationality.rejected, (state) => {
      state.addNationalityLoading = false;
    });

    builder.addCase(createEducationYear.pending, (state) => {
      state.createEducationYearLoading = true;
    });
    builder.addCase(createEducationYear.fulfilled, (state, action) => {
      state.createEducationYearLoading = false;
    });
    builder.addCase(createEducationYear.rejected, (state) => {
      state.createEducationYearLoading = false;
    });

    builder.addCase(createEducationHolidays.pending, (state) => {
      state.createEducationHolidaysLoading = true;
    });
    builder.addCase(createEducationHolidays.fulfilled, (state, action) => {
      state.createEducationHolidaysLoading = false;
    });
    builder.addCase(createEducationHolidays.rejected, (state) => {
      state.createEducationHolidaysLoading = false;
    });

    builder.addCase(createSemester.pending, (state) => {
      state.createSemesterLoading = true;
    });
    builder.addCase(createSemester.fulfilled, (state, action) => {
      state.createSemesterLoading = false;
    });
    builder.addCase(createSemester.rejected, (state) => {
      state.createSemesterLoading = false;
    });

    builder.addCase(createShift.pending, (state) => {
      state.createShiftLoading = true;
    });
    builder.addCase(createShift.fulfilled, (state, action) => {
      state.createShiftLoading = false;
    });
    builder.addCase(createShift.rejected, (state) => {
      state.createShiftLoading = false;
    });

    builder.addCase(getLanguages.fulfilled, (state, action) => {
      state.languages = action.payload;
    });

    builder.addCase(getJournalOptions.fulfilled, (state, action) => {
      state.activeClassRoom = action?.payload?.find(
        (el) => el.group_id === +action.meta.arg
      );
    });

    builder.addCase(getCities.fulfilled, (state, action) => {
      state.cities = action.payload;
    });

    builder.addCase(addCity.pending, (state) => {
      state.addCityLoading = true;
    });
    builder.addCase(addCity.fulfilled, (state, action) => {
      state.addCityLoading = false;
    });
    builder.addCase(addCity.rejected, (state) => {
      state.addCityLoading = false;
    });

    builder.addCase(getSocialStatuses.fulfilled, (state, action) => {
      state.socialStatuses = action.payload;
    });

    builder.addCase(getTargetedTraining.fulfilled, (state, action) => {
      state.targetedTrainings = action.payload;
    });

    builder.addCase(addEducationSpeciality.pending, (state) => {
      state.addEduSpecLoading = true;
    });
    builder.addCase(addEducationSpeciality.fulfilled, (state, action) => {
      state.addEduSpecLoading = false;
    });
    builder.addCase(addEducationSpeciality.rejected, (state) => {
      state.addEduSpecLoading = false;
    });

    builder.addCase(getEducationSpeciality.fulfilled, (state, action) => {
      state.eduSpecs = action.payload;
    });

    builder.addCase(addCabinetType.pending, (state) => {
      state.addCabinetTypeLoading = true;
    });
    builder.addCase(addCabinetType.fulfilled, (state, action) => {
      state.addCabinetTypeLoading = false;
    });
    builder.addCase(addCabinetType.rejected, (state) => {
      state.addCabinetTypeLoading = false;
    });

    builder.addCase(getCabinetTypes.fulfilled, (state, action) => {
      state.cabinetTypes = action.payload;
    });

    builder.addCase(addCafedra.pending, (state) => {
      state.addCafedraLoading = true;
    });
    builder.addCase(addCafedra.fulfilled, (state, action) => {
      state.addCafedraLoading = false;
    });
    builder.addCase(addCafedra.rejected, (state) => {
      state.addCafedraLoading = false;
    });

    builder.addCase(getCafedras.fulfilled, (state, action) => {
      state.cafedras = action.payload;
    });

    builder.addCase(getPersonIdByHikId.fulfilled, (state, action) => {
      state.personIdResponse = action.payload?.person_id;
    });

    builder.addCase(getStaffTypes.fulfilled, (state, action) => {
      state.staffTypes = action.payload;
    });
  },
});

export const {
  setSingleStaffObj,
  setSingleStudentInfo,
  setGroupCurriculum,
  setGroupsListOnArchivePage,
  setPersonId,
} = adminSlice.actions;

export default adminSlice.reducer;
